module.exports = __webpack_public_path__ + "static/media/icon_configuracion.a69493cb.png";